import { feedRows } from '@/mocks/gossip';
import SectionHead from './SectionHead';

const tagColor: Record<string, string> = {
  新实锤: 'bg-primary-100 text-primary-800',
  新截图: 'bg-accent-100 text-accent-800',
  新录音: 'bg-secondary-200 text-secondary-900',
  新视频: 'bg-accent-200 text-accent-900',
  线索: 'bg-secondary-100 text-secondary-900',
};

export default function FeedSection() {
  return (
    <section id="zhuizong" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <SectionHead
          en="Live Feed"
          title="最新追踪 · 每一条都在往前推进"
          desc="按时间倒序滚动更新当日新增的证据与线索，红色为最新实锤，绿色为新增影像与截图。"
          actionLabel="参与匿名投稿"
        />

        <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
          <div className="flex items-center justify-between border-b border-background-200 bg-background-50/80 px-4 py-2.5 md:px-5">
            <span className="inline-flex items-center gap-2 text-sm font-medium text-foreground-700">
              <span className="relative flex h-2.5 w-2.5">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary-400 opacity-75" />
                <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-primary-500" />
              </span>
              实时更新中
            </span>
            <span className="font-label hidden text-xs text-foreground-500 sm:block">
              今日新增 26 条材料
            </span>
          </div>
          <ul className="divide-y divide-background-100">
            {feedRows.map((row) => (
              <li key={row.id}>
                <a
                  href="#zhengju"
                  className="group flex flex-col gap-2 px-4 py-3.5 transition-colors hover:bg-secondary-50 sm:flex-row sm:items-center sm:gap-4 md:px-5"
                >
                  <span
                    className={`inline-flex w-fit shrink-0 items-center rounded-full px-2.5 py-0.5 text-xs font-medium whitespace-nowrap ${tagColor[row.tag] || 'bg-secondary-100 text-secondary-900'}`}
                  >
                    {row.tag}
                  </span>
                  <span className="min-w-0 flex-1 text-sm text-foreground-800 group-hover:text-primary-700">
                    {row.title}
                  </span>
                  <span className="hidden shrink-0 text-xs whitespace-nowrap text-foreground-500 lg:inline">
                    {row.category}
                  </span>
                  <span className="inline-flex shrink-0 items-center gap-1 text-xs whitespace-nowrap text-foreground-400">
                    <i className="ri-fire-line text-primary-400" />
                    {row.hot}
                  </span>
                  <span className="shrink-0 text-xs whitespace-nowrap text-foreground-400 sm:w-20 sm:text-right">
                    {row.time}
                  </span>
                </a>
              </li>
            ))}
          </ul>
          <div className="border-t border-background-200 px-4 py-3 text-center md:px-5">
            <a
              href="#zhengju"
              className="inline-flex items-center gap-1 text-sm font-medium text-primary-700 transition-colors hover:text-primary-600"
            >
              查看完整证据检索
              <i className="ri-arrow-down-line" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}